var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<table v-on=\"click: onClick\" class=\"custom_table\"><thead><tr><th>Тип контейнера</th><th>Контейнер</th><th>Транспорт</th><th>Место назначения</th></tr></thead><tfoot><tr><th v-show=\"!table.length\" colspan=\"4\">Нет информации о контейнерах</th></tr></tfoot><tbody><tr v-repeat=\"table\"><td title=\"{{* type.desc + ' / ' + size.desc + (permitted ? ' / Выдача запрещена отправителем':'')}}\"><span v-show=\"permitted\" class=\"icon-lock lock\"></span><span data-size=\"{{* size.id }}\" class=\"icon-container {{* type.id }}\"></span></td><td>{{{* number | parseTrainInWayLink $data}}}</td><td>{{* transport }}<span v-show=\"train\" class=\"stock\">Поезд {{* train}}</span><span v-show=\"station\" class=\"stock\">Станция {{* station}}</span></td><td>{{* destination }}</td></tr></tbody></table><component is=\"alert\" name=\"train-in-way\" data-message=\"{{ data.message }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/train-in-way/component.jade
 ** module id = 66
 ** module chunks = 0
 **/